// src/config.js
// export const SOCKET_SERVER_IP = "192.168.0.7"; 
// export const SOCKET_SERVER_IP = "10.10.32.139"; //Cikarang
// export const SOCKET_SERVER_IP = "31.97.105.252"; //Server
export const SOCKET_SERVER_IP = "rfid-be.suryasarana.com"; //Server Domain
export const API_BASE = `https://${SOCKET_SERVER_IP}`; // HTTPS, no port
export const SOCKET_PORT = 8094;
// export const API_BASE = `http://${SOCKET_SERVER_IP}:${SOCKET_PORT}`;
